export default __webpack_public_path__ + "static/media/No44Closed.02b1e9a9.jpg";